import React, {Component} from 'react';
import './CustomerGroupsInfluenceChangeSelects.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';

class CustomerGroupsInfluenceChangeSelects extends Component {
    constructor(props) {
        super(props);
        this.defaultParams = {};
        this.state = {
            influenceChange: '',
        };
    }
    
    onDataChange = (event) => {
        const value = event.target.value;
        this.setState({ influenceChange : value })
        this.props.customerGroupInfluenceChange(value, this.props.data.groupId)
    };

    render() {

        return(
            <div className='level-select-box'>
                <div className='form-group'>
                    <i class="fas fa-sort"></i>
                    <select onChange={(e) => { this.onDataChange(e)}} value={this.props.data.influenceChange} >
                        <option value=''>Future Level of Influence</option>
                        <option value='growing'>Growing</option>
                        <option value='shrinking'>Shrinking</option>
                        <option value='notChanging'>Not Changing</option>
                    </select>
                </div>
            </div>
        ) 
    }
}

export default (CustomerGroupsInfluenceChangeSelects);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerGroupsInfluenceChange/CustomerGroupsInfluenceChangeSelects/CustomerGroupsInfluenceChangeSelects.jsx